// extracted by mini-css-extract-plugin
export default {"container":"styles_container__H7whg","buttons":"styles_buttons__Ow-Nt","verifyBtn":"styles_verifyBtn__HMaLO"};